import styled, { css } from 'styled-components';
import { bonesCSS } from '@/components/Bones';
import { Button } from '@simplywallst/ui-core';

export const OverflowHidden = styled('div')`
  overflow: hidden;
`;

export const ContentBlock = styled('div')`
  ${({ theme }) =>
    css`
      ul {
        ${theme.typography.xSmall}
        margin-bottom: ${theme.x3spacePx}px;
        padding-left: 18px;
        li {
          list-style-type: square;
          margin-bottom: 12px;
          &::marker {
            color: ${theme.color.brand03};
          }
        }
      }
      p {
        ${theme.typography.xSmall}
      }
    `}
`;

export const Bones = styled('span')`
  ${bonesCSS}
  margin-top: 4px;
  margin-bottom: ${({ theme }) => theme.x2spacePx}px;
`;

export const ShowMoreButton = styled(Button)`
  &:before {
    ${({ theme }) => css`
      background: linear-gradient(
        180deg,
        ${theme.color.charcoalRGBA(0)} 0%,
        ${theme.color.charcoalRGBA(0.6)} 50%,
        ${theme.color.charcoalRGBA(1)} 100%
      );
    `}
    content: '';
    display: block;
    position: absolute;
    width: 100%;
    height: ${({ theme }) => theme.x8spacePx}px;
    top: -${({ theme }) => theme.x10spacePx}px;
    left: 0;
    pointer-events: none;
  }
`;
